import React from 'react';
import { Link } from 'react-router-dom';

/** True for full URLs (https:, mailto:, tel:, wa.me…), false for pages of the site (/about). */
export const isExternal = (url) => /^[a-z][a-z0-9+.-]*:/i.test(url || '');

/**
 * A link that can be a page of the site (router link: the /ar prefix is kept
 * automatically) or an external address (new tab).
 *   <SiteLink to={item.url} newTab={item.new_tab}>{item.label}</SiteLink>
 */
const SiteLink = React.forwardRef(function SiteLink({ to, newTab = false, children, ...rest }, ref) {
    if (!to) return <span ref={ref} {...rest}>{children}</span>;

    if (isExternal(to) || newTab) {
        const opensTab = newTab || /^https?:/i.test(to);
        return (
            <a ref={ref} href={to} {...(opensTab && { target: '_blank', rel: 'noopener noreferrer' })} {...rest}>
                {children}
            </a>
        );
    }

    return (
        <Link ref={ref} to={to} {...rest}>
            {children}
        </Link>
    );
});

export default SiteLink;
